export default {
  methods: {
    /** returns the application's base url */
    getBaseURL() {
      if (process.env.NODE_ENV === "production") {
        return "https://app.fincraft.de"
      } else if (process.env.NODE_ENV === "next") {
        return "https://next.fincraft.de"
      } else if (process.env.NODE_ENV === "test") {
        return "https://demo.fincraft.de"
      } else if (process.env.NODE_ENV === "dev") {
        return "https://dev.fincraft.de"
      } else if (process.env.NODE_ENV === "development") {
        return "http://localhost:8080"
      } else {
        // Default is production
        return "https://app.fincraft.de"
      }
    },
  }
}
